import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { IToken } from '../interfaces/Token'
import { Routes } from '../routes'

export default class AttendanceRecords extends Http {
  public async show(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.attendanceLogsPath(),
      token,
      params,
    )) as any
  }

  public async create(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'post',
      Routes.attendanceLogsPath(),
      token,
      params,
    )) as any
  }
}
